import React, { useState } from "react";

import TocDropdown from "../../../generic/tocDropdown";
import { FileUploadSection } from "../../generic/fileUploadSection";
import { segmentIncomeProof } from "./constant";

export const FileUpload = (props: any) => {
  const [dropValChanged, setDropValChanged] = useState(false);
  const [selectedSegincomeProof, setSelectedSegincomeProof] = useState({
    display: "ITR Proof",
    value: "ITRProof",
    desc: "Latest self attested ITR copy.",
  });

  const handleSubmit = (val: any) => {
    setDropValChanged(false);
    props.onSubmit({
      base64Data: val.base64Data,
      segDocFile: val.docFile,
      selectedSegincomeProof: selectedSegincomeProof.value,
    });
  };
  return (
    <>
      <div className="incomeProof">
        <div className="custom--row">
          <div className="custom-col">
            <TocDropdown
              selectedValue={selectedSegincomeProof.value}
              dropdownOptions={segmentIncomeProof}
              onSelect={(val: any) => {
                let value = segmentIncomeProof.filter((ele) => {
                  if (ele.value === val) return ele;
                });
                setDropValChanged(true);
                setSelectedSegincomeProof(value[0]);
              }}
              disabled={props.segDetails.disableEdit}
              isSearchable={false}
            />
          </div>
        </div>
      </div>
      <FileUploadSection
          disableCross={props.segDetails.disableEdit}
          fileType={["pdf"]}
          onSubmit={handleSubmit}
          fileSize={1048576}//1MB size
          dropValChanged={dropValChanged}
        />
    </>
  );
};
